import React, { useEffect, useState } from "react";
import { Box, Paper, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { useNavigate } from "react-router-dom";

const RegistrationSuccessful: React.FC = () => {
  const navigate = useNavigate();
  const [secondsLeft, setSecondsLeft] = useState(20);
  useEffect(() => {
    const header = document.querySelector(
      "header, .app-header, .header"
    ) as HTMLElement | null;
    if (!header) return;
    const prevDisplay = header.style.display;
    header.style.display = "none";
    return () => {
      header.style.display = prevDisplay;
    };
  }, []);
  useEffect(() => {
    const timer = setTimeout(() => navigate("/"), 10000);
    return () => clearTimeout(timer);
  }, [navigate]);
  useEffect(() => {
    if (secondsLeft <= 0) {
      navigate("/");
      return;
    }
    const id = setTimeout(() => setSecondsLeft(s => s - 1), 1000);
    return () => clearTimeout(id);
  }, [secondsLeft, navigate]);
  return (
    <Box
      sx={{
        backgroundColor: "#FFFFFF",
        minHeight: "100vh",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        px: { xs: 2, md: 4 },
        py: { xs: 3, md: 6 }
      }}
    >
      <Paper
        elevation={0}
        sx={{
          width: "100%",
          maxWidth: 1100,
          minHeight: "75vh",
          borderRadius: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: { xs: 3, md: 8 }
        }}
      >
        <Box sx={{ textAlign: "center", maxWidth: 520, mx: "auto" }}>
          <Box
            sx={{
              width: 52,
              height: 52,
              borderRadius: "50%",
              backgroundColor: "#34A853",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mx: "auto",
              mb: 3
            }}
          >
            <CheckIcon sx={{ color: "#fff", fontSize: 35 }} />
          </Box>

          <Typography
            sx={{ fontWeight: 700, fontSize: 18, color: "#000000", mb: 0 }}
          >
            You have been successfully registered on the
          </Typography>
          <Typography
            sx={{ fontWeight: 700, fontSize: 18, color: "#000000", mb: 2 }}
          >
            MoRTH Rajmarg Pravesh Portal.
          </Typography>

          <Typography
            variant="body2"
            sx={{ color: "#9E9E9E", fontWeight: 500, fontSize: 14 }}
          >
            Please do not close or refresh this window. You will be
            automatically redirected to the login page in {secondsLeft} seconds.
          </Typography>

          <Typography
            variant="body2"
            sx={{ color: "#9E9E9E", mt: 2.5, fontWeight: 500, fontSize: 14 }}
          >
            Or{" "}
            <span
              onClick={() => navigate("/")}
              style={{
                textDecoration: "underline",
                fontWeight: 700,
                cursor: "pointer",
                color: "#3A1C73"
              }}
            >
              Click Here
            </span>{" "}
            to Proceed Now
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
};

export default RegistrationSuccessful;
